<template>
  <div class="mt-3">
    <div class="description" v-html="content"
      :style="{'--fontSize': fontSize}" @click="contentClick($event)"></div>
    <vue-easy-lightbox
      :visible="lightbox.visible"
      :imgs="lightbox.imgs"
      :index="lightbox.index"
      @hide="lightboxHide"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
export default {
  name: 'CourseContent',
  props: ['content'],
  data() {
    return {
      fontSize: '1rem',
      lightbox: {
        imgs: '', // lightbox img
        visible: false,
        index: 1020, // default: 0
      },
    };
  },
  methods: {
    contentClick(e) {
      if (e.target.nodeName === 'IMG') {
        const { target } = e;
        this.lightbox.imgs = target.src;
        this.lightboxShow();
      }
    },
    lightboxShow() {
      this.lightbox.visible = true;
    },
    lightboxHide() {
      this.lightbox.visible = false;
    },
  },
  watch: {
  },
  mounted() {
    const vm = this;
    vm.fontSize = window.localStorage.getItem('biz_fontSize');
    vm.$bus.$on('changeFontSize', (value) => {
      vm.fontSize = value;
    });
  },
  created() {
  },
};
</script>

<style scoped>
/deep/ .description p {
  margin-bottom: 0;
  font-size: var(--fontSize);
}
/deep/ .description h2 {
  font-size: calc(var(--fontSize) + 1.5rem);
}
/deep/ .description h2 {
  font-size: calc(var(--fontSize) + 1rem);
}
/deep/ .description h3 {
  font-size: calc(var(--fontSize) + 0.75rem);
}
/deep/ .description h4 {
  font-size: calc(var(--fontSize) + 0.5rem);
}
/deep/ .description h5 {
  font-size: calc(var(--fontSize) + 0.25rem);
}
/deep/ .description img {
  display: block;
  max-width: 100%;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  /* width: 100% */
  height: auto;
}
</style>
